export const APP_NAME = 'Greener Stores'

export const PADDING_X = 6

export const HEADER_HEIGHT = 100

export const PAGE_NAMES = {
  assessments: {
    index: 'Assessments Listing',
    show: 'Assessment Timeline',
    store: 'Store Details'
  },
  certificationLetters: {
    index: 'Certification Letters',
    new: 'New Certification Letter'
  },
  scorecard: {
    show: 'Assessment Scorecard'
  },
  complianceReports: {
    stores: 'Compliance Report',
    report: 'Compliance Report'
  },
  verification: {
    report: 'Verification Report',
    strategy: 'Strategy Verification'
  }
}
